import React, { useEffect, useRef } from "react";
import { formatClock, formatLeft } from "../Helpers/webSession";

// The pop-up before a web sign-in ends. Plain markup (no Bootstrap modal) so the app's modal helpers leave it alone.
//  - kind "idle": nobody has used the page; any click or key press (or the button) keeps the sign-in going.
//  - kind "cap": the 12-hour limit; activity cannot move it, so the choice is to sign in again now or carry on.
const SessionWarning = ({ kind, leftMs, endsAt, onStay, onSignOut, onSignInAgain, onDismiss }) => {
    const primary = useRef(null);
    useEffect(() => {
        primary.current?.focus();
    }, [kind]);

    const idle = kind === "idle";
    return (
        <div className="session-warning-backdrop" role="presentation">
            <div className="session-warning" role="alertdialog" aria-modal="true" aria-labelledby="session-warning-title" aria-describedby="session-warning-text">
                <h5 id="session-warning-title" className="mb-2">{idle ? "Still there?" : "Your sign-in is about to end"}</h5>
                <p id="session-warning-text" className="mb-3">
                    {idle
                        ? <>You will be signed out in <strong className="session-warning-count">{formatLeft(leftMs)}</strong> because the page has not been used.</>
                        : <>For security, a sign-in lasts at most 12 hours. This one ends at <strong>{formatClock(endsAt)}</strong> ({formatLeft(leftMs)} left). Save your work, then sign in again.</>}
                </p>
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                    {idle ? (
                        <>
                            <button type="button" className="btn btn-outline-secondary" onClick={onSignOut}>Sign out now</button>
                            <button type="button" className="btn btn-primary" ref={primary} onClick={onStay}>Stay signed in</button>
                        </>
                    ) : (
                        <>
                            <button type="button" className="btn btn-outline-secondary" onClick={onDismiss}>Keep working</button>
                            <button type="button" className="btn btn-primary" ref={primary} onClick={onSignInAgain}>Sign in again now</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SessionWarning;
